export default "__VITE_ASSET__CH3xY5NU__"